// auth.js

import Cookies from 'js-cookie';
import axios from 'axios';

const TOKEN_KEY = 'jwtToken';

export const isProduction = () => {
  // let ret = (process.env.NODE_ENV === 'production');
  let ret = !(window.location.hostname === 'localhost')
  // ret = true;
  return ret;

}

const secure = isProduction();

export const storeToken = (token) => {
  // Cookies.set(TOKEN_KEY, token, { sameSite: "None", secure:secure });
  Cookies.set(TOKEN_KEY, token, { sameSite: "Lax", secure:secure });
};

export const fetchToken = () => {
	const token = Cookies.get(TOKEN_KEY);
	// console.log('token:',token)
  return token;
};

export const removeToken = () => {
    // Cookies.remove(TOKEN_KEY, { sameSite: "None", secure: secure }); 
    Cookies.remove(TOKEN_KEY, { sameSite: "Lax", secure: secure }); 
};


const nw_error_catcher = (error, logout) => {
  if (error.response) {
    const { status } = error.response;

    // Handle 401 Unauthorized
    if (status === 401) {
      console.error('Token expired or unauthorized access');
      localStorage.setItem('sessionExpired', 'true'); // Set session expired flag
      // Optionally: Refresh token logic or redirect to login
      // refreshToken(); or redirectToLogin();
      if (logout) {
        logout();
      }
      throw error
    }

    if (status === 403) {
      // This error is handled in OnPlanEndErrorHandler
      console.error('error 403', 'FORBIDDEN');    
      // if (logout) {
        // logout();
        
      //}
      throw error;
     
    }    
  
    if (status === 404) {
      console.error('error 404', 'resource unavailable');    
      if (logout) {
        logout();
      }
      // throw new Error('resource unavailble');
    }    

    // Handle other HTTP status codes as needed
    console.log(`HTTP error ${status}: ${error.response.data}`);
    throw error;
  } else if (error.request) {
    // Handle network or server unavailability
    console.error('No response received from server', error);
    throw error
  } else {
    // Handle other errors (e.g., setup or axios issues)
    console.error('Error in request setup:', error.message);
    throw error;
  }

}

export const post_auth = async (uri, data, logout) => {
  const token = fetchToken();
  if ((token == null) && logout) {
    logout();
  }
  const auth_header = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };

  try {
    // Make the POST request
    return await axios.post(uri, data, auth_header);
  } catch (error) {
    // Check if the error is an HTTP response error
    nw_error_catcher(error, logout);

  }
};

export const post_auth_mp = async (uri, data) => {
  const token = fetchToken();
  const auth_header = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  };
  return axios.post(uri, data, auth_header);
};

export const get_auth = async (uri, params = {}, resp_type = 'blob', logout) => {
  const token = fetchToken();
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`
    },
    responseType: resp_type,
    params: params
  };  
  let ret = null;
  try {
    ret = await axios.get(uri, config);
    console.log('get return', ret)
  } catch (error) {
    nw_error_catcher(error, logout);
  }
  return ret; 
};

export const getAuthAsync = async (uri, params = {}, respType = 'blob') => {
  try {
    const token = fetchToken(); // Synchronous call
    if (!token) {
      throw new Error('No token found');
    }
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      responseType: respType,
      params: params
    };
    const response = await axios.get(uri, config);
    return response;
  } catch (err) {
    console.error('Failed to get authorization:', err);
    return null; 
  }
};


